module.exports = __webpack_public_path__ + "img/block-diagram-container-hovered.2b5d664e.png";